import COM from './ImagePreloader'

export default COM
